import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";

import styles from "./NewNavigation.css";

export default function DropdownItemWrapperTag({
  item,
  tag,
  mobileToggle,
  className,
  ...props
}) {
  const WrapperTag = tag;

  return (
    <WrapperTag
      {...props}
      className={classNames(styles.item, className, {
        [`${item.className}-hamburger`]: item.className,
      })}
      onClick={event => {
        if (tag == "button" && item.onClick) {
          mobileToggle();
          item.onClick(event);
        } else if (tag == Link && item.onClick) {
          mobileToggle();
        } else {
          item.onClick && item.onClick(event);
        }
      }}
    >
      {item.name}
    </WrapperTag>
  );
}

DropdownItemWrapperTag.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
    internal: PropTypes.bool,
    className: PropTypes.string,
    onclick: PropTypes.func,
  }).isRequired,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  mobileToggle: PropTypes.func,
  to: PropTypes.string,
  href: PropTypes.string,
  className: PropTypes.string,
};
